import * as React from 'react';
import { styled } from 'styled-components';

import { theme } from '../../styles';
import { CircularCheckmarkIcon } from '../../assets/icons';
import { extendChildrenWithProps } from '../../utils';
import { Headings } from '../Headings';
import { Container, Flex, Spacer } from '../Layout';
import { Text } from '../Text';

const StyledFlex = styled(Flex)<{ isCompleted: boolean; id: string }>`
  background-image: linear-gradient(
    ${props => (props.isCompleted ? theme.colors.black90 : theme.colors.black30)} 27%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: left;
  background-size: 1px 8px;
  background-repeat: repeat-y;
  :last-child {
    padding-bottom: 0;
    background: none;
  }
`;

const CustomSpan = styled.span`
  transform: translateX(-46%);
`;

type TimelineProps = {
  title?: string;
  children: React.ReactNode;
  currentStep: number;
};

export const Timeline = ({ title, currentStep, children }: TimelineProps) => {
  const renderSteps = React.Children.map(children, (child, index) => {
    let isActive = false;
    let isCompleted = false;

    const currentStepIndex = index;

    if (currentStepIndex === currentStep) {
      isActive = true;
    } else if (currentStepIndex < currentStep) {
      isCompleted = true;
    }

    return extendChildrenWithProps(child, { isActive, isCompleted });
  });

  return (
    <>
      {title && <Headings.H4 marginBottom={[20, 30, 40]}>{title}</Headings.H4>}
      <Container marginLeft={8}>{renderSteps}</Container>
    </>
  );
};

type TimelineStepProps = any & {
  id: string;
  text: string;
  button?: JSX.Element;
  dateLabel?: string;
};

Timeline.Step = ({ id, text, dateLabel, isActive, isCompleted, button }: TimelineStepProps) => (
  <StyledFlex id={id} paddingBottom={40} alignItems="flex-start" isCompleted={isCompleted}>
    <CustomSpan>
      <CircularCheckmarkIcon color="white" width={22} variant={isCompleted ? 'tick' : isActive ? 'dot' : 'empty'} />
    </CustomSpan>
    <Spacer marginLeft={12} marginTop={-3}>
      {dateLabel && <Headings.H4 marginBottom={2}>{dateLabel}</Headings.H4>}
      <Text marginBottom={5}>{text}</Text>
      {button ? button : null}
    </Spacer>
  </StyledFlex>
);
